/**
 * StatusBar Component
 * Shows status updates during processing (tool execution, etc.).
 */

import { Box, Typography } from '@mui/material';
import LoadingIndicator from './LoadingIndicator';

const StatusBar = ({ status }) => {
  if (!status) return null;

  return (
    <Box sx={{
      px: 2,
      py: 1.25,
      backgroundColor: '#f0f4f8',
      borderTop: '1px solid #e0e0e0',
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
    }}>
      <LoadingIndicator variant="dots" />
      <Typography variant="body2" color="text.secondary">
        {status}
      </Typography>
    </Box>
  );
};

export default StatusBar;
